export class Util {
  constructor() {
    if (this instanceof Util) {
      throw Error("A static class cannot be instantiated.");
    }
  }

  static capitalizeFirstLetter(word) {
    if (typeof word == "number") return word;
    if (!word || typeof word != "string") return "";
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  //  fieldname = field name as it is on the form
  //  value = field value or chosen answer
  //  template = object that holds all the input options

  static mapFormFieldToLabel(fieldname, value, template) {
    if (!template) return "";
    if (!fieldname) return "";
    if (!template[fieldname]) return "";
    const item = template[fieldname].find((item) => item.value === value || item.key === value || item.id === value);
    console.log(item);
    return item?.label;
  }

  static mapFieldToAcct(fieldname, value, template) {
    if (!template) return "";
    if (!fieldname) return "";
    if (!template[fieldname]) return "";
    const item = template[fieldname].find((item) => item.value === value || item.key === value || item.id === value);
    console.log(item);
    return `${item?.productName} ${item?.accountNo}`;
  }
}
